<template>
  <div class="lxwm">
    <div class="lxwmTitle titleImg">
      <img class="image" src="./lxwm/lxwm.png"  alt="">
    </div>
     <div class="contactBt">
       <!-- <img src="./lxwm/bt.png" class="image" alt=""> -->
       联系我们
     </div>
     <div class="zkzg  ">
        <img src="./lxwm/zkzg.png" class="UsImage" alt="">
        <div class="contactWay">
          <div class="contactWayTitle" >公司联系方式</div>
          <div class="contactN" >
            <!-- <div class="contactCentent" ><img src="./lxwm/xx.png" alt=""><span>zsh424@126.com</span></div> -->
            <div class="contactCentent" ><img src="./lxwm/xp.png" alt=""> <span>400-991-9533</span></div>
            <!-- <div class="contactCentent" ><img src="./lxwm/xh.png" alt=""><span>400-991-9533</span></div> -->
            <div class="contactCentent" ><img src="./lxwm/xd.png" alt=""><span>河南省郑州市二十三大街中科智谷创新园12号楼7层</span></div>
            <!-- <div class="contactCentent" ><img src="./lxwm/xt.png" alt=""><span>工作时间  9:00/12:00-13:30/17:30</span></div> -->
          </div>
        </div>
     </div>
     <div class="contactMap">
          <!-- <img src="./lxwm/map.png" class="image" alt=""> -->
          <BaiDuMap/>
      </div>
  </div>
</template>

<script>
import BaiDuMap from '@/components/BaiDuMap/BaiDuMap.vue'
export default {
  components: {
    BaiDuMap
  }
}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.lxwm{
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: center;
  background-color: #fff;
  width: 100%;
  .lxwmTitle{
    width: 100%;
  }
  .titleImg{
  height: 460px*$sun;
}
  .image{
    width: 100%;
    height: 100%;
  }
  .contactBt{
    width: 524px*$sun ;
    height: 52px*$sun ;
    margin:60px*$sun auto;
    font-size: 40px*$sun;
    font-weight: 500;
    text-align: center;
  }
  .zkzg{
    margin: auto;
    width: 1200px*$sun;
    height: 467px*$sun;
    // padding: 0 360px*$sun 60px*$sun 360px*$sun;
    position: relative;
    .UsImage{
      width: 604px*$sun;
      height: 403px*$sun;
    }
    .contactWay{
      position: absolute;
      right: 0;
      bottom: 0;
      width: 710px*$sun;
      height: 305px*$sun;
      // height: 255px*$sun;
      background: #FFFFFF;
      box-shadow: 0px .125rem .625rem rgba(0,0,0,0.1);
      display: flex;
      flex-direction: column;
      // padding: 50px*$sun  0 50px*$sun 101px*$sun;
      padding: 50px*$sun  0 0px*$sun 101px*$sun;
      box-sizing: border-box;
      // 动画
    transition: all 0.2s;
      .contactN{
        // display: flex;
        // justify-content: space-between;
        // align-content: flex-start;
        // flex-direction: column;
        // height: 214px*$sun;
        height: 150px*$sun;
       .contactCentent{
          display: flex;
          align-items: center;
          height: 22px*$sun;
          // margin-bottom: 26px*$sun;
          margin-bottom: 30px*$sun;
          width: 507px*$sun;
          margin-right: 0;
          span{
            padding-left: 13px*$sun;
            font-size: 16px*$sun;
            font-weight: 500;
          }
        }
      }

      .contactWayTitle{
        margin-bottom: 50px*$sun;
        height: 29px*$sun;
        font-size: 21px*$sun;
        font-weight: 500;
        line-height: 32px*$sun;
        color: #333333;
        width: 507px*$sun;
        font-weight: 500;
      }
    }
          .contactWay:hover{
   /* 盒子向上移动 */
    transform: translateY(-2px*$sun);
    /* 背景 */
    box-shadow: 5px*$sun 5px*$sun 5px*$sun rgba(19, 19, 20, 0.15);
    // text-shadow: 5px*$sun 5px*$sun 5px*$sun #7676f3;
 }
  }
  .contactMap{
    width: 1200px*$sun;
    display: flex;
    justify-content: center;
    margin: 60px*$sun auto;
    // padding: 60px*$sun 360px*$sun;
  }
}

</style>
